export const SET_MINI = 'SET_MINI'
export const SET_IS_PENDO_LOADED = 'SET_IS_PENDO_LOADED'
export const SET_APP_STATE = 'SET_APP_STATE'
export const SET_HOME_LAYOUT = 'SET_HOME_LAYOUT'
export const SET_PROJECT_LAYOUT = 'SET_PROJECT_LAYOUT'
export const SET_TOGGLE_PROJECT_DRAWER = 'SET_TOGGLE_PROJECT_DRAWER'
export const SET_NAVIGATION_DRAWER_PROFILE = 'SET_NAVIGATION_DRAWER_PROFILE'
export const SET_BADGE_PROFILE_VISIBLE = 'SET_BADGE_PROFILE_VISIBLE'
export const SET_ROUTER_HISTORY = 'SET_ROUTER_HISTORY'
